import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { initializeTelegramWebApp } from "./telegram/webapp";
import "./styles/tokens.css";
import "./styles/app.css";

initializeTelegramWebApp();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
